var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnAlertFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 19.2,
    viewBox: "0 0 16 19.2",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.835 13.53a5.358 5.358 0 0 1 -1.9-4.1v-2.23a5.6 5.6 0 0 0 -4.8-5.536v-.864a.8.8 0 0 0 -1.6 0v.864a5.6 5.6 0 0 0 -4.8 5.536v2.23a5.364 5.364 0 0 1 -1.91 4.106 1.4 1.4 0 0 0 .907 2.464h13.2a1.4 1.4 0 0 0 .9-2.47zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.228 450.4a3 3 0 0 0 2.939-2.4h-5.878a3 3 0 0 0 2.939 2.4zm0 0",
    transform: "translate(-129.896 -431.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAlertFill);
export default __webpack_public_path__ + "static/media/icn_alert-fill.a66cea72113ce1c01abcd4f0aee3a9a5.svg";
export { ForwardRef as ReactComponent };